import React from 'react';
import { BryModal } from '../UI/BryUI';
import RegisterEarnings from '../Earnings/RegisterEarnings';
import RegisterFueling from '../Fuelings/RegisterFueling';
import PriceCalculator from '../DELIVERY/Calculator/PriceCalculator';
import RegisterMaintenance from '../Maintenances/RegisterMaintenance';

const HomeModals = ({ 
    showEarningModal, setShowEarningModal, 
    showFuelModal, setShowFuelModal, 
    showCalcModal, setShowCalcModal, 
    showMaintModal, setShowMaintModal, 
    fetchData 
}) => (
    <>
        <BryModal 
            isOpen={showEarningModal} 
            onClose={() => setShowEarningModal(false)} 
            title="Registrar Ganancia"
        >
            <RegisterEarnings onClose={() => { setShowEarningModal(false); fetchData(); }} />
        </BryModal>
        <BryModal 
            isOpen={showFuelModal} 
            onClose={() => setShowFuelModal(false)} 
            title="Registrar Combustible"
        >
            <RegisterFueling onClose={() => { setShowFuelModal(false); fetchData(); }} />
        </BryModal>
        <BryModal 
            isOpen={showCalcModal} 
            onClose={() => setShowCalcModal(false)} 
            title="Calculadora"
            size="lg"
        >
            <PriceCalculator />
        </BryModal>
        <BryModal 
            isOpen={showMaintModal} 
            onClose={() => setShowMaintModal(false)} 
            title="Mantenimiento"
            size="lg"
        >
            <RegisterMaintenance onClose={() => { setShowMaintModal(false); fetchData(); }} />
        </BryModal>
    </>
);

export default HomeModals;
